import { render, staticRenderFns } from "./RepPreventa.vue?vue&type=template&id=70439503&"
import script from "./RepPreventa.vue?vue&type=script&lang=js&"
export * from "./RepPreventa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports